import Vue from 'vue'


const actions = {
    checkIfProductIsKnownInOrder: ({state, rootGetters, dispatch}, payload) => {
        let orders = _.map(rootGetters['orders/getOrdersFromCargo'](payload.cargoId), (order) => {
            return parseInt(order.id)
        })

        return _.find(state.orderProducts, (product) => {
                console.log(product)
            if (product.productNumber.trim() == payload.barcode.trim()
                && _.includes(orders, product.orderId)
                && product.amount > (product.amountLoaded ? product.amountLoaded : 0)) {
                return product
            }
        })
    },
    checkAmountPicked: ({state}, payload) => {
        let product = state.orderProducts[payload]
        if (product.location.amountPicked < product.location.amount) {
            return true
        } else {
            return {error: 'max_amount_picked'}
        }
    },
    fullProductInfo: ({state, getters, rootState, rootGetters}, product) => {
        let locations = _.filter(rootState.pickLocations.pickLocations, (pickloc) => {
                return product.orderId == pickloc.orderId
            }
        )

        let orderProduct = state.orderProducts[product.id]
        orderProduct.locations = _.orderBy(locations, ['amount', 'asc'])
        return orderProduct
    },
    /**
     * Payload represents orderProdcut inculuding all pick locations
     * @param state
     * @param commit
     * @param rootGetters
     * @param dispatch
     * @param payload
     * @returns {{error: string}|boolean}
     */
    incrementAmountPicked: ({state, commit, rootGetters, dispatch}, payload) => {
        let locationToUpdate = null;

        _.each(payload.locations, (loc) => {
            if (locationToUpdate) {
                return false
            }
            if (!payload.scannedLocation || loc.name == payload.scannedLocation.name) {
                if (!loc.amountPicked) {
                    loc.amountPicked = 0
                }
                if (loc.amountPicked < loc.amountPickable) {
                    loc.amountPicked = (loc.amountPicked + 1)
                    locationToUpdate = loc
                }
            }
        })
        if (locationToUpdate) {
            let pickedProductData = {
                ...rootGetters['orders/getCurrentProductPicking'],
                endTime: new Date(),
                orderId: payload.orderId,
                sourceLocation: payload.scannedLocation ? payload.scannedLocation.id : locationToUpdate.locationRecordId
            }

            dispatch('pickLocations/patch', locationToUpdate, {root: true}).then(() => {
                Vue.prototype.$FB.collection('outgoing-products').add(pickedProductData)
            })
            commit('orders/setCurrentProductPicking', null, {root: true})
            return true
        } else {
            return {error: 'max_amount_picked'}
        }

    }
}

export default actions


